import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FETCH_REVIEWS_PHOTOS_PAGE } from 'features/reviews-photos/actions/reviews-photos';
import {
  getReviewsPhotosPagesCount,
  getReviewsPhotosLoading,
  getHasMoreReviewsPhotos,
} from 'features/reviews-photos/selectors/reviews-photos';
import { GalleryPhoto, setPhotosCollection, setPhotosModalSource, showPhoto } from 'features/reviews';
import {
  getAllPhotosFromReviews,
  getIsGroupRatings,
  getReviewGroupSorting,
} from 'features/reviews/selectors';
import { PdpBuyerGallery } from './pdp-gallery-buyer-view';

export const PdpReviewsGalleryBuyer = () => {
  const dispatch = useDispatch();
  const isGroupRatings = useSelector(getIsGroupRatings);

  const photos = useSelector(getAllPhotosFromReviews);
  const defaultActiveTab = useSelector(getReviewGroupSorting);
  const nextPhotosPageIndex = useSelector(getReviewsPhotosPagesCount);
  const isPhotosLoading = useSelector(getReviewsPhotosLoading);
  const hasMorePhotos = useSelector(getHasMoreReviewsPhotos);

  const onShowPicture = useCallback(
    (pic: GalleryPhoto | null, photosForModal: GalleryPhoto[]) => {
      dispatch(setPhotosModalSource('gallery'));
      dispatch(setPhotosCollection(photosForModal));
      dispatch(showPhoto(pic));
    },
    [dispatch],
  );

  const fetchNextPhotos = useCallback(
    (currentPage: number) => dispatch(FETCH_REVIEWS_PHOTOS_PAGE.request({ currentPage })),
    [dispatch],
  );

  if (!isGroupRatings) return null;

  return (
    <PdpBuyerGallery
      photos={photos}
      defaultActiveTab={defaultActiveTab}
      onShowPicture={onShowPicture}
      fetchNextPhotos={fetchNextPhotos}
      nextPhotosPageIndex={nextPhotosPageIndex}
      isPhotosLoading={isPhotosLoading}
      hasMorePhotos={hasMorePhotos}
    />
  );
};
